import { textFieldsInit } from "./mtui/text_field";

document.addEventListener('DOMContentLoaded', function() {
    textFieldsInit();
});

